import { IUser, User } from '@pozi/authmodule';
import { UserModulesMap } from './auth/user-modules-map.interface';

export class CompanyUser extends User {
  title?: string;
  lastName: string;
  firstName: string;
  companies: ICompany[];

  constructor(raw: ICompanyUser) {
    super(raw);
    this.title = raw.title;
    this.lastName = raw.lastName;
    this.firstName = raw.firstName;
    this.companies = raw.companies;
  }

  get typedModules(): UserModulesMap {
    return this.modules as UserModulesMap;
  }
}

export interface ICompanyUser extends IUser {
  title?: string;
  lastName: string;
  firstName: string;
  companies: ICompany[];
}

export interface ICompany {
  name: string;
  id: number;
  sites: ISite[];
}

export interface ISite {
  name: string;
  id: number;
  default: boolean;
}
